import "./auth.scss";

// image
import { images } from "../../constants/images";

// component
import Signin from "./Signin";
import Signup from "./Signup";
import ResetPassword from "./ResetPassword";
import RequestResetPassword from "./RequestResetPassword";

const Auth = ({ action }: { action: string }) => {
  return (
    <div className="auth">
      <div className="topbar">
        <img src={images.topbar} alt="Top bar" />
      </div>
      {action === "signin" ? (
        <Signin />
      ) : action === "signup" ? (
        <Signup />
      ) : action === "resetpwrequest" ? (
        <RequestResetPassword />
      ) : action === "resetpw" ? (
        <ResetPassword />
      ) : (
        ""
      )}
    </div>
  );
};

export default Auth;
